// 最新改版的接口

import request from '@/utils/new_request/index'
console.log(request, 'requestrequestrequestrequest')
export function getArticleList(params) {
  return request.get({ url: '/article/lists', params })
}
export function getArticleDetail(params) {
  return request.get({ url: '/article/detail', params })
}

// 注册
export function addRegister(params) {
  return request.post({ url: '/login/register', params })
}

// 修改密码
export function changePassword(params) {
  return request.post({ url: '/user/changePassword', params })
}

// 获取验证码
export function getSendEmail(params) {
  return request.get({ url: '/login/sendEmail', params })
}

export function loginAccount(data) {
  return request.post({ url: '/login/account', data })
}
// 个人信息
export function getUserInfo(params) {
  return request.get({ url: '/user/info', params })
}

// 查看自己是否报名
export function getIsAddActive(params) {
  return request.get({ url: '/registration/isAddActive', params })
}
// 修改个人信息
export function editUserInfo(data) {
  return request.post({ url: '/user/setInfo', data })
}

// 获取小组信息
export function getGroupInfoList(params) {
  return request.get({ url: '/registration/getGroup', params })
}
// 报名
export function addRegistration(data) {
  return request.post({ url: '/registration/add', data })
}

// 报名查看详情
export function getRegistrationInfo(params) {
  return request.get({ url: '/registration/getOwnActive', params })
}

// 获取前台时间点
export function getExamFrontTime(params) {
  return request.get({ url: '/competition/getExam', params })
}

// 获取主题
export function getThemeList(params) {
  return request.get({ url: '/userWork/getMatchCenter', params })
}

// 提交作品
export function addUserWork(data) {
  return request.post({ url: '/userWork/add', data })
}

// 获取评论列表
export function getCommentList(params) {
  return request.get({ url: '/comment/getArticleIdComment', params })
}

// 评论
export function addComment(data) {
  return request.post({ url: '/comment/add', data })
}

/**
 * 作品列表
 * @param {*} params 
 * @returns 
 */
export function getUserWorkList(params) {
  return request.get({ url: '/userWork/lists', params })
}
export function getUserWorkInfo(params) {
  return request.get({ url: '/userWork/getById', params })
}

/**
 * 倒计时
 * @param {*} params 
 * @returns 
 */
export function getRegistrationInfoIsDateBack(params) {
  return request.get({ url: '/registration/isDateBack', params })
}
// 上传图片
export const uploadImage = (data, callback) => {
  const { file, type } = data
  const formData = new FormData()
  if (Array.isArray(file)) {
    file.map((file) => {
      formData.append('file', file)
    })
  } else {
    formData.append('file', file)
  }
  formData.append('type', type)
  return request.request({
    url: '/upload/image',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData,
    onUploadProgress: (e) => {
      callback && callback(e)
    },
    timeout: 6000000
  })
}
